import { LogoSpotifyForArtists } from '@spotify-internal/encore-web/core';
import styled from 'styled-components';
import { flyoutTransitionMixin } from '../FlyoutMenu/config';
export const S4ALogo = styled(LogoSpotifyForArtists) `
  ${flyoutTransitionMixin('fill')}
  fill: ${props => props.theme.text};
`;
//# sourceMappingURL=index.js.map